export class ReservePlanEdit {
  targetYear!:number
  unitPrice!:number
  incomePlan!:number
}

export class ReservesPostRequest {
  reservePlan:ReservePlanEdit[] = []
}
